module.exports = __webpack_public_path__ + "static/img/google-play-badge-ca.da5e7b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-badge-ca.png
// module id = zwi3
// module chunks = 1